import arrowRight from '../../images/icons/arrow-right.svg';
import app1 from '../../images/icons/app-1.svg';
import app2 from '../../images/icons/app-2.svg';
import app3 from '../../images/icons/app-3.svg';
import app4 from '../../images/icons/app-4.svg';
import app5 from '../../images/icons/app-5.svg';
import help from '../../images/icons/help.svg';
import hearts from '../../images/icons/hearts.svg';
import burger from '../../images/icons/burger.svg';
import close from '../../images/icons/close.svg';

const mapping = {
  'arrow-right': arrowRight,
  'app-1': app1,
  'app-2': app2,
  'app-3': app3,
  'app-4': app4,
  'app-5': app5,
  'help': help,
  'hearts': hearts,
  'burger': burger,
  'close': close
};

export { mapping };
